export default {
  // Follows & friend requests (social layer)
  async createFollow(targetUserId, privacyRealmId = null, message = null, relationshipType = 'friend_request') {
    return this.request('/follows', {
      method: 'POST',
      body: {
        target_user_id: targetUserId,
        relationship_type: relationshipType,
        ...(privacyRealmId ? { privacy_realm_id: privacyRealmId } : {}),
        ...(message ? { message } : {}),
      },
    });
  },

  async followUser(targetUserId) {
    return this.createFollow(targetUserId, null, null, 'follow');
  },

  async getIncomingFollows({ status = null, relationship_type = null, limit = 50, offset = 0 } = {}) {
    const qs = new URLSearchParams({
      limit: String(limit),
      offset: String(offset),
      ...(status ? { status } : {}),
      ...(relationship_type ? { relationship_type } : {}),
    }).toString();
    return this.request(`/follows/incoming?${qs}`);
  },

  async getOutgoingFollows({ status = null, relationship_type = null, limit = 50, offset = 0 } = {}) {
    const qs = new URLSearchParams({
      limit: String(limit),
      offset: String(offset),
      ...(status ? { status } : {}),
      ...(relationship_type ? { relationship_type } : {}),
    }).toString();
    return this.request(`/follows/outgoing?${qs}`);
  },

  async getMyFollowers({ limit = 50, offset = 0 } = {}) {
    const qs = new URLSearchParams({
      limit: String(limit),
      offset: String(offset),
    }).toString();
    return this.request(`/follows/followers?${qs}`);
  },

  async respondToFollow(followId, { action, privacy_realm_id, share } = {}) {
    return this.request(`/follows/${followId}/respond`, {
      method: 'PUT',
      body: { action, ...(privacy_realm_id ? { privacy_realm_id } : {}), ...(share ? { share } : {}) },
    });
  },

  async getPublicProfile() {
    return this.request('/users/me/public-profile');
  },

  async setPublicProfile(privacyRealmId, selections = {}) {
    return this.request('/users/me/public-profile', {
      method: 'PUT',
      body: { privacy_realm_id: privacyRealmId, ...selections },
    });
  },

  // The page itself, as it reads: the nodes your public profile shows.
  async getMyPublicView() {
    return this.request('/users/me/public-profile/view');
  },

  async deletePublicProfile() {
    return this.request('/users/me/public-profile', { method: 'DELETE' });
  },

  async revokeFollow(followId) {
    return this.request(`/follows/${followId}`, {
      method: 'DELETE',
    });
  },

  // Sharing (EP-based — creates exposure_profile entity_type='friend')
  async createSharing(data) {
    return this.request('/sharing', {
      method: 'POST',
      body: data,
    });
  },

  async updateSharing(sharingId, updates) {
    return this.request(`/sharing/${sharingId}`, {
      method: 'PUT',
      body: updates,
    });
  },
};
